import { RefObject } from "react";
import { Toast } from "primereact/toast";
import { Timesheet } from "domain/entities/timesheet";
import { TimesheetDay } from "domain/entities/timesheet-day";
import { Employee } from "domain/entities/employee";

export interface ValidateTimesheetParams {
    timesheet?: Timesheet | null;
    localTimesheetDays?: TimesheetDay[];
    daysByNumber: Map<number, TimesheetDay>;
    userEmployee?: Employee | null;
    extraHourPoIds: Set<string>;
    toastRef?: RefObject<Toast | null>;
}

export const getDaysInMonth = (year: number, month: number): number => {
    return new Date(year, month, 0).getDate();
};

export const validateTimesheet = ({
    timesheet,
    daysByNumber,
    userEmployee,
    extraHourPoIds,
    toastRef,
}: ValidateTimesheetParams): boolean => {
    if (!timesheet) return false;
    const totalDays = getDaysInMonth(timesheet.year, timesheet.month);
    const expectedHours = userEmployee?.workHoursPerDay ?? 8;

    for (let day = 1; day <= totalDays; day++) {
        const date = new Date(timesheet.year, timesheet.month - 1, day, 12, 0, 0, 0);
        const isWeekend = date.getDay() === 0 || date.getDay() === 6;

        if (!userEmployee?.isSuportService && isWeekend) {
            continue;
        }

        const tsd = daysByNumber.get(day);

        const projectHours = (tsd?.purchaseOrders ?? []).reduce((sum, po) => {
            const isExtra = po.id ? extraHourPoIds.has(po.id) : false;
            return isExtra ? sum : sum + (po.hours ?? 0);
        }, 0);

        const absenceHours = tsd?.abscenceTime ?? 0;
        const totalDayHours = projectHours + absenceHours;

        if (totalDayHours !== expectedHours) {
            const dayFormatted = String(day).padStart(2, "0");
            const monthFormatted = String(timesheet.month).padStart(2, "0");

            toastRef?.current?.show({
                severity: "warn",
                summary: "Advertência",
                detail: `A soma das horas do dia ${dayFormatted}/${monthFormatted}/${timesheet.year} (${totalDayHours} horas) não é igual às suas horas diárias contratualizadas (${expectedHours} horas).`,
                life: 5000,
            });
            return false;
        }
    }

    return true;
};